module.exports = __webpack_public_path__ + "img/78000.7876778a.jpg";